import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Md5 } from 'ts-md5/dist/md5';


import { AlertType, MessageError } from 'base-models';

import { BaseLoginComponent } from 'basecomponents';
import { AuthenticationServiceAbs, AUTH_SERVICE_PROVIDER_TOKEN } from 'baseauth';
import { environment } from '@app-environments/environment';
import { interval, timer } from 'rxjs';

@Component({
    selector: 'app-dashboard',
    templateUrl: 'login2.component.html'
    , styleUrls: ['./login.component.scss'],
    providers: [Md5]
})
export class LoginComponent extends BaseLoginComponent implements OnInit {
    //TODO: ELIMINAR LO QUE NO SEA NECESARIO DESPUES DE HEREDAR DE BASELOGINCOMPONENT
    title = "E-Solar";
    loginForm: FormGroup;
    loadinglist = false;
    submitted = false;
    returnUrl: string;
    isLoginError: boolean = true;
    alertmessage: MessageError;
    appversion: string;

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    constructor(
        public formBuilder: FormBuilder,
        public route: ActivatedRoute,
        public router: Router,
        @Inject(AUTH_SERVICE_PROVIDER_TOKEN) public authenticationService: AuthenticationServiceAbs
    ) {
        super(formBuilder, route, router, authenticationService);
        this.appversion = environment.appVersion;
    }

    private changeTitle() {
        if (this.title == "GeoAI") {
            this.title = "E-Solar";
        } else {
            this.title = "GeoAI";
        }
    }

    ngOnInit() {
        this.getScreenSize();
        let usertest = environment.user_test;
        let userpwd = environment.user_pwd;
        this.loginForm = this.formBuilder.group({
            username: [usertest, Validators.required],
            password: [userpwd, Validators.required]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
    showbg = false;
    changebg() {
        this.showbg = !this.showbg;
    }

    screenmessage: MessageError = null;
    getScreenSize(event?) {
        let scrHeight = screen.height;
        let scrWidth = screen.width;
        console.log("Windows width/height" + scrWidth + " " + scrHeight);
        if (scrWidth < 1920) {
            this.screenmessage = new MessageError(AlertType.Warning, "Minimum recommended resolution is Full HD (1920x1080).");
        }
    }


    fieldTextType: boolean;
    toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
    }

}

